import React from 'react';

import { TAlertMessage } from '@/Utils/useAlertMessage';

export const AlertMessageBooking = ({ type, description }: TAlertMessage) => {
  return (
    <div className={`flash ${type} fixed z-10 bottom-4 left-4`}>
      <div className='message'>
        <p>{description}</p>
      </div>
    </div>
  );
};
